import { FormWithRedux } from '../../FormWithRedux';
import { FormLoader } from '../../FormLoader';


export class EDChestPainKeyClinicalFeaturesForm extends FormWithRedux {

    constructor(formIdentifier, parent, actionUpdater, dependentValuesUpdater, calculationsUpdater) {
        super(formIdentifier, parent, actionUpdater, dependentValuesUpdater, calculationsUpdater);
    }

    shouldDisplayFormDetailForIdentifier(identifier) {
        super.shouldDisplayFormDetailForIdentifier(identifier);
        if (identifier === 'followUpReason') {
            let isFollowUpScanDetail = FormLoader.formDetail(this.pathwayId, identifier);
            return isFollowUpScanDetail.currentValue == null ? false : isFollowUpScanDetail.currentValue;
        }

        return true;
    }

    isEnabled(identifier) {
        if (identifier != null) {
            return true;
        }
        return false;
    }

    isMandatory(identifier) {
        if (identifier != null) {
            return true;
        }
        return false;
    }

    getValueType() {


        return 'boolean';
    }

    submissionValidation() {
        return [];
    }

    detailString(isSubform) {
        let formDetails = this.getFormDetails();
        let values = formDetails.map((value) => {
            return (value.valueDescription() == null || value.valueDescription() == false) ? null : (isSubform ? '- ' : '') + value.valueDescription();
        });

        if(values.filter(n => n).length == 0) {
            return isSubform ? '' : this.detail;
        }

        return values.filter(n => n).join(',\n');
    }

}


// WEBPACK FOOTER //
// ./src/forms/edChestPain01/Forms/EDChestPain-KeyClinicalFeaturesForm.js